















import AppSocial from "@/components/AppSocial.vue";
import { Layout } from "@/types/layout";
import url from "@/mixins/analytics/url";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component({ components: { AppSocial } })
export default class AppFooter extends Mixins(url) {
  @State("layout") layout!: Layout;

  @Prop({ required: false, default: false })
  showPoweredBy!: boolean;
}
